import React from 'react';

export interface CustomIconProps {
  disabled?: boolean;
}

export default abstract class CustomIcon extends React.Component<CustomIconProps> {
  abstract svg(): JSX.Element;

  render() {
    return React.cloneElement(this.svg(), {
      className: `custom-icon${this.props.disabled ? ' disabled' : ''}`,
    });
  }
}
